module.exports = __webpack_public_path__ + "static/media/fave-feed-post-submitted-review.71c2f657.svg";